'use client';

import Box from '@mui/material/Box';

import SideMenu from '@/ui/components/SideMenu';

export default function Aside({ links }) {
  return (
    <Box mt={6}>
      <SideMenu heading="usefulLinks" items={links} />
    </Box>
  );
}
